import { type IconProps } from '../iconProps';

export const IconNext: React.FC<IconProps> = ({ size, fill }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 9 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.765625 1.79898C0.765718 1.59745 0.819943 1.39965 0.922631 1.22625C1.02532 1.05285 1.1727 0.910217 1.34937 0.81326C1.52604 0.716303 1.72551 0.668582 1.92693 0.675086C2.12835 0.681589 2.32433 0.742079 2.49437 0.850231L7.52387 4.05048C7.68355 4.15209 7.815 4.29234 7.90608 4.45824C7.99715 4.62415 8.0449 4.81035 8.0449 4.99961C8.0449 5.18886 7.99715 5.37507 7.90608 5.54097C7.815 5.70688 7.68355 5.84712 7.52387 5.94873L2.49437 9.14973C2.32427 9.25792 2.12823 9.31841 1.92674 9.32488C1.72526 9.33135 1.52573 9.28357 1.34904 9.18652C1.17235 9.08947 1.02498 8.94673 0.922344 8.77322C0.81971 8.59972 0.765584 8.40182 0.765625 8.20023V1.79898Z'
        fill={fill}
      />
    </svg>
  );
};
